export const geometrieConfig = {
  Tp: {
    label: "Tecno penta",
    parametri: {
      areaP: 10,
      areaInt: 10,
      diam: 35.7,
      hManic: 13.37,
      supManic: 150,
      hSetto: null,
      peso: 2,
      ct: 10,
      passo: 2,
      angolo: 60,
      baricentro: 0,
    },
  },
  P200kN: {
    label: "Pagani 200kN",
    parametri: {
      areaP: 10,
      areaInt: 10,
      diam: 35.7,
      hManic: 13.3,
      supManic: 150,
      hSetto: null,
      peso: 1.5,
      ct: 10,
      passo: 2,
      angolo: 60,
      baricentro: 0,
    },
  },
  DD: {
    label: "Deep drill",
    parametri: {
      areaP: 10,
      areaInt: 8.5,
      diam: 35.7,
      hManic: 13.3,
      supManic: 150,
      hSetto: null,
      peso: 2,
      ct: 20,
      passo: 20,
      angolo: 60,
      baricentro: 30,
    },
  },
  P200kN63: {
    label: "Pagani tg63",
    parametri: {
      areaP: 10,
      areaInt: 10,
      diam: 35.7,
      hManic: 13.3,
      supManic: 150,
      hSetto: null,
      peso: 2,
      ct: 10,
      passo: 20,
      angolo: 60,
      baricentro: 30,
    },
  },
  P100kN: {
    label: "Pagani 100kN",
    parametri: {
      areaP: 10,
      areaInt: 8.5,
      diam: 35.7,
      hManic: 13.3,
      supManic: 150,
      hSetto: null,
      peso: 2,
      ct: 10,
      passo: 20,
      angolo: 60,
      baricentro: 30,
    },
  },

};

